import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ResourceService} from '../../services/resource/resource.service';
import {PriceDetail} from '../../model/ocapi/price-detail';
import {OmapiIdsUtils} from '../utils/omapi-ids/omapi-ids-utils';
import {
  productTypeRendition,
  ProductTypeRenditionEnum
} from '../../constants/renditions/product-type-rendition.constants';

@Component({
  selector: 'app-price-per-month',
  templateUrl: './price.component.html',
  styleUrls: ['./price.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PriceComponent implements OnInit {
  private _priceDetail: PriceDetail;

  @Input() isPlay: boolean;
  @Input() isBannerPriceBox: boolean;
  @Input() promoTextKey: string;
  @Input() rendition: productTypeRendition = ProductTypeRenditionEnum.default;
  StreamingBundleProductTypeRendition = ProductTypeRenditionEnum.streamingBundle;
  NetflixStandaloneProductTypeRendition = ProductTypeRenditionEnum.netflixStandalone;
  DisneyStandaloneProductTypeRendition = ProductTypeRenditionEnum.disneyStandalone;

  @Input()
  omapiId: string;

  @Input()
  textKeyWithParameter;
  private _backgroundColor: string;

  @Input()
  set priceDetail(value) {
    this._priceDetail = value;
  }

  constructor(private resourceService: ResourceService) {
  }

  ngOnInit(): void {
    this.fetchBackgroundColor();
  }

  private fetchBackgroundColor() {
    if (this.omapiId) {
      this.resourceService.getColourForProduct(OmapiIdsUtils.getCorrectIdForResource(this.omapiId)).subscribe(color => this._backgroundColor = color);
    } else {
      // default background color for price box
      this._backgroundColor = '#64ae65';
    }
  }

  get priceDetail(): PriceDetail {
    return this._priceDetail;
  }

  get backgroundColor(): string {
    return this._backgroundColor;
  }
}
